module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled,
      "v-show": _vm.visible
    },
    on: {
      "click": _vm.showLookupDialog
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('js-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "title": _vm.title == null ? _vm.buttonText : _vm.title,
      "entity": _vm.entity,
      "checkSelectable": _vm.checkSelectable,
      "condition": _vm.condition,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "filter-fields": _vm.dialogFilterFields,
      "searchPlaceholder": _vm.searchPlaceholder
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a09d49d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup-chooser/src/lookup-chooser.vue
// module id = 691
// module chunks = 220